import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { ToastContainer, toast } from "react-toastify";
import { getUserSurveyManufacturerParticipants } from "../../Utils/userFunctions";
import { useParams, Link } from "react-router-dom";
import { get_Date, getSurveyStatusName } from "../../Utils/commonFunctions";
import { Table } from "react-bootstrap";
import dataTableGrid from "../DataTableGrid";
function UserSurveyParticipantsDetails() {
  const [surveyData, setSurveyData] = useState("");
  const [participantList, setParticipantList] = useState("");
  const [surveyStatus, setSurveyStatus] = useState("");
  const { surveyID } = useParams();
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getUserSurveyManufacturerParticipants(surveyID);
      if (response.status == "success") {
        setSurveyData(response.data[0]);
        setParticipantList(response.participantsList);
        setSurveyStatus(response.data[0].status);
        dataTableGrid({
          data_table_id: "#participant_list",
          paginate: false,
          copy_option: [0, 1, 2, 3, 4, 5, 6, 7],
          csv_option: [0, 1, 2, 3, 4, 5, 6, 7],
          print_option: [0, 1, 2, 3, 4, 5, 6, 7],
          sort_option: [],
        });
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);
  return (
    <>
      <UserHeader />
      <ToastContainer></ToastContainer>
      <div className="container">
        <div className="row mt-4">
          <div className="col-md-4">
            <div className="card vd-card">
              <div className="card-body">
                <div className="pmcf-content-info">
                  <span className="custom_survey_name">
                    {surveyData.survey_name}
                  </span>
                  <hr
                    style={{
                      border: "1px solid #006CB5",
                      borderRadius: 10,
                    }}
                  />
                  <div className="pmcf-survey-list" style={{ marginTop: "5%" }}>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Status</div>
                      <div className="pmcf-survey-value">
                        {getSurveyStatusName(surveyStatus)}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Launch Date</div>
                      <div className="pmcf-survey-value">
                        {surveyData.launch_date
                          ? get_Date(surveyData.launch_date)
                          : "Survey is yet to be launched"}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Completion Date</div>
                      <div className="pmcf-survey-value">
                        {get_Date(surveyData.completion_date)}
                      </div>
                    </div>
                  </div>
                  <div className="pmcf-survey-question-point">
                    <h2 style={{ color: "#006CB5" }}>
                      {" "}
                      {surveyData.no_of_question}
                    </h2>
                    <p style={{ color: "black" }}>QUESTIONS</p>
                  </div>
                  <div className="pmcf-survey-list">
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">
                        Number of Participants
                      </div>
                      <div className="pmcf-survey-value">
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                    <div className="pmcf-survey-item">
                      <div className="pmcf-survey-text">Responses</div>
                      <div className="pmcf-survey-value">
                        {surveyData.no_of_responses} /
                        {surveyData.no_of_paticipants}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="card vd-card">
              <p className="text-right m-2">
                <Link
                  to={"/UserSurveyDetails/" + surveyID}
                  className="btn btn-sm custom-btn-primary pull-right"
                >
                  <i className="fa fa-arrow-left"></i> Back
                </Link>
              </p>
              <div className="card-body">
                <div className="card-table">
                  <div className="table-responsive">
                    <Table
                      id="participant_list"
                      bordered
                      size="sm"
                      className="table-sm"
                    >
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Email</th>
                          <th>Profession</th>
                          <th>Region</th>
                          <th>Country</th>
                          <th>Contact No</th>
                        </tr>
                      </thead>
                      <tbody>{participantList}</tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default UserSurveyParticipantsDetails;
